import { contrastRatio } from '@yola/yola-palette-generator';
import reduceColorPointByRatio from '../../../../common/utils/reduce-color-point-by-ratio';

const dark = (params) => {
  const { targetColor, backgroundColor, targetColorPalette } = params;
  const fallback = {
    rule: 'dropdown.listRowBackground.selected.dark',
    params,
  };
  if (contrastRatio(backgroundColor, targetColor) >= 1.5) {
    return targetColor;
  }
  return reduceColorPointByRatio(
    {
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.5,
      fallback,
    },
    '900'
  );
};

export default dark;
